(function () {
  'use strict';
  if (window.VermolaWishlist) return;

  var STORAGE_KEY = 'vermola_wishlist_v1';

  function read() {
    try {
      var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function write(handles) {
    var clean = Array.from(new Set(handles.filter(Boolean)));
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(clean)); } catch (error) {}
    updateUI(clean);
    document.dispatchEvent(new CustomEvent('vermola:wishlist-change', { detail: { handles: clean } }));
    return clean;
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var handles = read();
    var index = handles.indexOf(handle);
    if (index === -1) handles.unshift(handle);
    else handles.splice(index, 1);
    return write(handles);
  }

  function remove(handle) { return write(read().filter(function (item) { return item !== handle; })); }

  function updateUI(handles) {
    handles = handles || read();
    document.querySelectorAll('[data-vr-wishlist-count]').forEach(function (node) {
      node.textContent = String(handles.length);
      node.hidden = handles.length === 0;
    });
    document.querySelectorAll('[data-vr-wishlist-button]').forEach(function (button) {
      var active = handles.indexOf(button.dataset.productHandle) !== -1;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = button.querySelector('[data-vr-wishlist-label]');
      if (label) label.textContent = active ? button.dataset.removeText : button.dataset.addText;
    });
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function productCard(product, page) {
    var compare = Number(product.compare_at_price || 0);
    var price = Number(product.price || 0);
    var sale = compare > price;
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var productURL = product.url || ('/products/' + product.handle);
    var addLabel = page.dataset.addText || 'Add to cart';
    var chooseLabel = page.dataset.chooseText || 'Choose options';
    var soldLabel = page.dataset.soldOutText || 'Sold out';
    var availableVariants = (product.variants || []).filter(function (variant) { return variant.available; });
    var directAdd = availableVariants.length === 1 && (product.variants || []).length === 1;
    var actionText = !product.available ? soldLabel : (directAdd ? addLabel : chooseLabel);
    var action = product.available
      ? (directAdd
          ? '<button type="button" class="vr-wishlist-card__action" data-vr-wishlist-add data-variant-id="' + availableVariants[0].id + '">' + escapeHTML(actionText) + '</button>'
          : '<a class="vr-wishlist-card__action" href="' + escapeHTML(productURL) + '">' + escapeHTML(actionText) + '</a>')
      : '<span class="vr-wishlist-card__action" aria-disabled="true">' + escapeHTML(actionText) + '</span>';

    return '<article class="vr-wishlist-card" data-vr-wishlist-card="' + escapeHTML(product.handle) + '">' +
      '<div class="vr-wishlist-card__media">' +
        '<a href="' + escapeHTML(productURL) + '"><img class="vr-wishlist-card__image" src="' + escapeHTML(image) + '" alt="' + escapeHTML(product.title) + '" loading="lazy" width="700" height="933"></a>' +
        '<button type="button" class="vr-wishlist-card__remove" data-vr-wishlist-remove="' + escapeHTML(product.handle) + '" aria-label="' + escapeHTML(page.dataset.removeText || 'Remove from wishlist') + '">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="vr-wishlist-card__content">' +
        '<a class="vr-wishlist-card__title" href="' + escapeHTML(productURL) + '">' + escapeHTML(product.title) + '</a>' +
        '<div class="vr-wishlist-card__prices">' +
          (sale ? '<span class="vr-wishlist-card__compare">' + money(compare) + '</span>' : '') +
          '<span class="vr-wishlist-card__price' + (sale ? ' is-sale' : '') + '">' + money(price) + '</span>' +
        '</div>' + action +
      '</div>' +
    '</article>';
  }

  function renderPage(page) {
    if (!page || page.dataset.vrReady === 'true') return;
    page.dataset.vrReady = 'true';
    var grid = page.querySelector('[data-vr-wishlist-grid]');
    var loading = page.querySelector('[data-vr-wishlist-loading]');
    var empty = page.querySelector('[data-vr-wishlist-empty]');
    var handles = read();

    function showEmpty() {
      if (loading) loading.hidden = true;
      if (grid) grid.innerHTML = '';
      if (empty) empty.classList.add('is-visible');
    }

    if (!handles.length) { showEmpty(); return; }

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Missing product'); return response.json(); })
        .catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);
      var validHandles = valid.map(function (product) { return product.handle; });
      if (validHandles.length !== handles.length) write(validHandles);
      if (loading) loading.hidden = true;
      if (!valid.length) { showEmpty(); return; }
      if (empty) empty.classList.remove('is-visible');
      grid.innerHTML = valid.map(function (product) { return productCard(product, page); }).join('');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-vr-wishlist-button]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      toggle(button.dataset.productHandle);
      return;
    }

    var removeButton = event.target.closest('[data-vr-wishlist-remove]');
    if (removeButton) {
      var wishlistPage = removeButton.closest('[data-vr-wishlist-page]');
      removeButton.closest('[data-vr-wishlist-card]').remove();
      var handles = remove(removeButton.dataset.vrWishlistRemove);
      if (!handles.length) {
        if (wishlistPage) {
          var empty = wishlistPage.querySelector('[data-vr-wishlist-empty]');
          if (empty) empty.classList.add('is-visible');
        }
      }
      return;
    }

    var addButton = event.target.closest('[data-vr-wishlist-add]');
    if (addButton) {
      addButton.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(addButton.dataset.variantId), quantity: 1 }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('Add failed');
        addButton.textContent = addButton.closest('[data-vr-wishlist-page]').dataset.addedText || 'Added';
      }).catch(function () {
        addButton.disabled = false;
      });
    }
  });

  function init(scope) {
    updateUI();
    (scope || document).querySelectorAll('[data-vr-wishlist-page]').forEach(renderPage);
  }

  window.VermolaWishlist = { read: read, write: write, has: has, toggle: toggle, remove: remove, refresh: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
